import { Stack } from "@mui/material";
import { useMemo } from "react";
import { Match } from "../directus/collections";
import { formatSecondsToDDHHMMSS } from "../libs/utils";

export function MatchEnigmaStatsDataList({
  match,
  enigmaId,
}: {
  match: Match;
  enigmaId: string;
}) {
  const stats = useMemo(() => {
    return match.steps_challenge_stats?.find((s) => s.id === enigmaId) || {};
  }, [match]);

  return (
    <dl>
      <Stack direction="row" spacing={2}>
        <dt>Challenge ID</dt>
        <dd>{stats?.id || "N/D"}</dd>
      </Stack>
      <Stack direction="row" spacing={2}>
        <dt>Errori totali</dt>
        <dd>{stats?.errors || 0}</dd>
      </Stack>
      <Stack direction="row" spacing={2}>
        <dt>Aiuti usati</dt>
        <dd>
          {stats?.used_hints || 0} / {stats?.total_hints || 0}
        </dd>
      </Stack>
      <Stack direction="row" spacing={2}>
        <dt>Soluzione richiesta</dt>
        <dd>{stats?.requested_answer ? "Sì" : "No"}</dd>
      </Stack>
      <Stack direction="row" spacing={2}>
        <dt>Bonus</dt>
        <dd>{stats?.bonus || 0}</dd>
      </Stack>
      <Stack direction="row" spacing={2}>
        <dt>Malus Errori</dt>
        <dd>{stats?.malus_errors || 0}</dd>
      </Stack>
      <Stack direction="row" spacing={2}>
        <dt>Malus Risposte</dt>
        <dd>{stats?.malus_answers || 0}</dd>
      </Stack>
      <Stack direction="row" spacing={2}>
        <dt>Malus Aiuti</dt>
        <dd>{stats?.malus_hints || 0}</dd>
      </Stack>
      <Stack direction="row" spacing={2}>
        <dt>Punteggio</dt>
        <dd>{stats?.score || 0}</dd>
      </Stack>
      <Stack direction="row" spacing={2}>
        <dt>Punteggio Max</dt>
        <dd>{stats?.score_max || 0}</dd>
      </Stack>
      <Stack direction="row" spacing={2}>
        <dt>Avviato il</dt>
        <dd>{stats?.init && new Date(stats?.init).toLocaleString()}</dd>
      </Stack>
      <Stack direction="row" spacing={2}>
        <dt>Terminato il</dt>
        <dd>{stats?.end && new Date(stats?.end).toLocaleString()}</dd>
      </Stack>
      <Stack direction="row" spacing={2}>
        <dt>Tempo di risoluzione</dt>
        <dd>{formatSecondsToDDHHMMSS(stats?.resolution_time || 0)}</dd>
      </Stack>
    </dl>
  );
}
